import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { environment } from '../environments/environment';
import { OfflineLandingPageComponent } from './playbook-viewer/shared/components/offline-landing-page/offline-landing-page.component';

const routes: Routes = [
  {
    path: 'playbook',
    loadChildren: () => import('./playbook-viewer/playbook-viewer.module').then(m => m.PlaybookViewerModule)
  },
  {
    path: 'offline/resourcelanding',
    component: OfflineLandingPageComponent
  }
];

const routeConfig: ExtraOptions = !environment.isOffline ? { onSameUrlNavigation: 'reload' } : { useHash: true };

@NgModule({
  imports: [RouterModule.forRoot(routes, routeConfig)],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
